import { motion, Variants, easeOut } from "framer-motion";

const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const textVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, x: 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.5, ease: easeOut },
  },
};

export const Duvidas = () => {
  return (
    <section
      id="duvidas"
      className="px-6 py-12"
    >
      <motion.h2
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={textVariants}
        className="text-xl font-bold mb-6 md:text-4xl"
      >
        Dúvidas Frequentes
      </motion.h2>

      <motion.ul
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
        className="space-y-6 pl-6 mb-16"
      >
        {[
          "Como as anilhas são aplicadas nas aves?",
          "Posso escolher o número de identificação?",
          "As anilhas machucam as aves?",
          "Elas resistem ao ambiente externo?",
          "As anilhas mudam o comportamento das aves?",
          "Posso usar o mesmo tipo de ",
        ].map((q, i) => (
          <motion.li
            key={i}
            variants={itemVariants}
            className="flex flex-col md:flex-row items-start gap-4"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-100 text-green-700 font-bold">
              ?
            </div>
            <div>
              <h4 className="font-semibold">{q}</h4>
              <p className="text-gray-700 text-sm mt-1 leading-relaxed">
                {[
                  "As anilhas são colocadas nas patas das aves ainda jovens, quando seu crescimento permite o encaixe correto. Elas permanecem no lugar durante toda a vida da ave.",
                  "Sim! Você pode escolher a gravação, o que inclui as informações e numeração sequencial.",
                  "Não. Nossas anilhas são leves e feitas com materiais seguros, projetadas para não causar desconforto.",
                  "Sim. São projetadas para resistir a condições climáticas comuns, como sol, chuva e vento.",
                  "Quando aplicadas corretamente, não interferem no comportamento natural.",
                  "Não. Cada espécie tem um tamanho adequado de anilha. É fundamental usar o modelo certo para garantir conforto e segurança. Fabricamos anilhas para filhotes e também aves adultas.",
                ][i]}
              </p>
            </div>
          </motion.li>
        ))}
      </motion.ul>
    </section>
  );
};
